<template>
  <v-card>
    <v-card-title v-if="options.title">
      <span class="headline">{{ options.title }}</span>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text>
      <ValidationObserver
        ref="form"
        tag="form"
        @submit.prevent="save"
      >
        <ValidationProvider
          v-if="!stored.id"
          rules="required"
          vid="school"
          :name="$t('fields.school').toLowerCase()"
          v-slot="{ errors }"
        >
        <AutoComplete
          ref="schoolField"
          v-model="form.school_id"
          key-value="id"
          key-name="fullname"
          enable-chips
          enable-clearable
          enable-autofocus
          :items="schools"
          :label="$t('fields.school')"
          @search="searchSchools"
          @input="fetchSchoolLocationIfExist"
          @clear="resetLocation"
          :loading="loading"
          :delay="900"
          :errors="errors"
        >
        </AutoComplete>
        </ValidationProvider>
        <v-simple-table
          v-if="!stored.id && schoolsLocations.length"
        >
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left"></th>
                <th class="text-left">{{ $t('fields.code') }}</th>
                <th class="text-left">{{ $t('fields.city') }}</th>
                <th class="text-left">{{ $t('fields.address') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in schoolsLocations" :key="item.id">
                <td>
                  <ValidationProvider
                    rules="required"
                    vid="school_location_id"
                    :name="$t('fields.location').toLowerCase()"
                    v-slot="{ errors }"
                  >
                    <v-radio-group
                      v-model="form.school_location_id"
                      :error-messages="errors"
                    >
                      <v-radio :value="item.id"></v-radio>
                    </v-radio-group>
                  </ValidationProvider>
                </td>
                <td>{{ item.code }}</td>
                <td>{{ item.city }}</td>
                <td>{{ item.street }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>

        <v-alert
          v-if="form.school_id && (data.stored == null && !schoolsLocations.length)"
          type="error"
        >

          {{ $t('error_this_school_not_not_contain_a_valid_address') }}
        </v-alert>

        <ValidationProvider
            v-if="!stored.id"
            rules="required"
            vid="subject_id"
            :name="$t('fields.subject').toLowerCase()"
            v-slot="{ errors }"
        >
          <v-select
            :items="subjects"
            v-model="form.subject_id"
            item-text="name"
            item-value="id"
            :label="$t('fields.subject')"
            :error-messages="errors"
          >
          <template v-slot:append-item>
            <div v-intersect="endIntersect" />
          </template>
          </v-select>
        </ValidationProvider>

        <ValidationProvider
            vid="classes"
            :name="$t('fields.classes').toLowerCase()"
            v-slot="{ errors }"
        >
        <v-text-field
            v-model="form.classes"
            :label="$t('fields.classes')"
            :error-messages="errors"
          >
          </v-text-field>
        </ValidationProvider>

    </ValidationObserver>
    </v-card-text>
    <v-card-actions>
      <v-btn
        @click="save"
        color="primary"
        :disabled="form.school_id && !form.school_location_id"
      >
        {{ $t('SAVE') }}
      </v-btn>
      <v-btn @click="cancel">{{ $t('CANCEL') }}</v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
  import { mapActions, mapState } from 'vuex';

  import { schoolsService } from '../../../utils/services/schools.service';
  import { schoolsLocationsService } from '../../../utils/services/schoolsLocations.service';
  import { subjectsService } from '../../../utils/services/subjects.service';
  import { teachersService } from '../../../utils/services/teachers.service';
  import { teachersSchoolsService } from '../../../utils/services/teachersSchools.service';
  import AutoComplete from '../../shared/Inputs/AutoComplete';

  export default {
    name: 'SchoolPropagandistModal',
    components: { AutoComplete },
    data() {
      return {
        searchSchool: null,
        searchSubject: null,
        stored: null,
        schools: [],
        subjects: [],
        schoolsLocations: [],
        teacher: {},
        currentTeacherSchool: {},
        form: {
          id: 0,
          teacher_id: null,
          school_location_id: null,
          subject_id: null,
          school_id: null,
          classes: null,
        },
        loading: false,
        paginations: {
          subjects: {
            current_page: 1,
            last_page: 1,
          },
        },
      };
    },
    computed: {
      ...mapState('modal', ['options', 'data']),
    },
    methods: {
      ...mapActions('alert', ['showToast']),
      ...mapActions('modal', ['hideModal', 'loadingModal']),
      async endIntersect(entries, observer, isIntersecting) {
      if (isIntersecting) {
        if (this.paginations.subjects.current_page + 1 <= this.paginations.subjects.last_page) {
          const moreSubjects = await this.fetchSubjects(this.paginations.subjects.current_page + 1);
          this.subjects = [...this.subjects, ...moreSubjects];
        }
      }
    },

      async save() {
        const isValid = await this.$refs.form.validate();
        if (isValid) {
            if (this.options.onSave) {
              this.loadingModal(true);
              this.options.onSave(
                this.form,
                this.errors,
              )
              .then(() => {
                  this.loadingModal(false);
              })
              .catch(error => {
                  this.handleError(error, this.errors);
              });
            }
        }
      },
      cancel() {
        this.hideModal({});
      },

      focusSchool() {
        this.$nextTick(() => {
          setTimeout(() => {
            const field = this.$refs.schoolField;
            if (field && field.focus) {
              field.focus();
            }
          }, 250);
        });
      },

      fetchSubjects(page) {
        return subjectsService.index({
          page: page || 1,
          itemsPerPage: (this.form.subject_id) ? 1000 : 15,
          filters: {
            sortBy: ['name'],
            sortDesc: [true],
          },
        })
        .then(response => {
          const { current_page, last_page } = response.data.meta;
          this.paginations.subjects.current_page = current_page;
          this.paginations.subjects.last_page = last_page;
          return response.data.data;
        })
        .catch(error => {
            this.handleError(error, this.errors);
            return [];
        });
      },

      fetchTeacher(id) {
        return teachersService.get(id)
        .then(response => {
            this.teacher = response.data.data;
        })
        .catch(error => {
            this.handleError(error, this.errors);
        });
      },

      async fetchSchools() {
        return schoolsService.index({
          filters: {
            search: this.searchSchool,
          },
        })
        .then(response => {
            this.schools = response.data.data;
        })
        .catch(error => {
            this.handleError(error, this.errors);
        });
      },

      async fetchSchoolLocationIfExist(val) {
        this.form.school_id = val;
        if (this.form.school_id) {
          this.fetchSchoolLocation();
        }
      },

      async fetchSchoolLocation() {
        return schoolsLocationsService.index(this.form.school_id)
        .then(response => {
            this.schoolsLocations = response.data.data;
            if (this.schoolsLocations.length) {
              this.form.school_location_id = this.schoolsLocations[0].id;
            }
        })
        .catch(error => {
            this.handleError(error, this.errors);
        });
      },
      async fetchSchoolTeacher() {
        return teachersSchoolsService.get(this.form.teacher_id, this.form.id)
        .then(response => {
            this.currentTeacherSchool = response.data.data;
        })
        .catch(error => {
            this.handleError(error, this.errors);
        });
      },

      searchSchools(val) {
        this.searchSchool = val;
        this.fetchSchools();
      },

      searchSubjects(val) {
        this.searchSubject = val;
        this.fetchSubjects();
      },

      resetLocation() {
        this.form.school_id = null;
        this.form.school_location_id = null;
        this.schoolsLocations = [];
      },
    },
    async created() {
      this.loadingModal(true);
      if (this.data.stored) {
        this.stored = this.data.stored;
        this.form.teacher_id = this.stored.teacher_id;
        await this.fetchTeacher(this.stored.teacher_id);
        this.form.subject_id = this.teacher.default_subject_id;
        this.subjects = await this.fetchSubjects();
        if (this.stored.id) {
          this.form.id = this.stored.id;
          this.form.school_location_id = this.stored.school_location_id;
          this.form.school_id = this.stored.school_id;

          await this.fetchSchoolTeacher();

          this.form.classes = (this.currentTeacherSchool.options && this.currentTeacherSchool.options.classes) ? this.currentTeacherSchool.options.classes : '';
        }
      }
      this.loadingModal(false);
      if (!this.stored || !this.stored.id) {
        this.focusSchool();
      }
    },
  };
</script>
